let polyfillsLoaded = false;

function supportsSmoothScroll(): boolean {
  if (typeof document === 'undefined') return true;
  return 'scrollBehavior' in document.documentElement.style;
}

function supportsIntersectionObserver(): boolean {
  return typeof window !== 'undefined' && 'IntersectionObserver' in window;
}

function supportsResizeObserver(): boolean {
  return typeof window !== 'undefined' && 'ResizeObserver' in window;
}

export async function loadCompatibilityPolyfills(): Promise<void> {
  if (polyfillsLoaded || typeof window === 'undefined') return;
  polyfillsLoaded = true;

  const tasks: Array<Promise<unknown>> = [];

  if (!supportsSmoothScroll()) {
    tasks.push(
      import('smoothscroll-polyfill').then((mod) => {
        mod.polyfill();
      }),
    );
  }

  if (!supportsIntersectionObserver()) {
    tasks.push(import('intersection-observer'));
  }

  if (!supportsResizeObserver()) {
    tasks.push(
      import('resize-observer-polyfill').then((mod) => {
        const ResizeObserverCtor = mod.default;
        if (!('ResizeObserver' in window)) {
          (window as Window & { ResizeObserver?: typeof ResizeObserverCtor }).ResizeObserver =
            ResizeObserverCtor;
        }
      }),
    );
  }

  // Adds :focus-visible behavior for keyboard users on browsers that do not support it natively.
  tasks.push(import('focus-visible'));

  if (tasks.length > 0) {
    await Promise.allSettled(tasks);
  }
}
